import { put } from "redux-saga/effects";

import * as actionTypes from "constants/actionTypes";

export function* replaceAccountGoalStats(data) {
  yield put({
    type: actionTypes.REPLACE_ACCOUNT_GOAL_STATS,
    payload: data || {}
  });
}
